// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Home bandwidth graph chrome */

.bandwidth-pane {
  --customer360-muted: #6c757d;
  --customer360-card-bg: #ffffff;
  --customer360-card-border: #dee2e6;
  --bandwidth-pane-muted: #6c757d;
  --bandwidth-pane-grid: #dee2e6;
  --bandwidth-pane-axis: #6c757d;
  --bandwidth-pane-tooltip-bg: #ffffff;
  --bandwidth-pane-tooltip-fg: #212529;
  overflow: hidden;
  padding: 0;
}

.bandwidth-pane__header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.bandwidth-pane__controls {
  gap: 0;
}

.bandwidth-pane__body {
  padding: 0.75rem 1rem 1rem;
}

.bandwidth-pane__header .customer360-snapshot__title-block {
  min-width: 0;
  flex: 1 1 auto;
}

.bandwidth-pane__select .form-control,
.bandwidth-pane .bandwidth-pane__controls .form-control {
  background-color: transparent;
  border: 1px solid var(--customer360-card-border, #dee2e6);
  color: inherit;
  border-radius: 0.35rem;
}

:root[data-theme="dark"] .bandwidth-pane {
  --customer360-muted: #9ca3af;
  --customer360-card-bg: #1f1f1f;
  --customer360-card-border: #2b2f33;
  --bandwidth-pane-muted: #9ca3af;
  --bandwidth-pane-grid: #3a3f44;
  --bandwidth-pane-axis: #9ca3af;
  --bandwidth-pane-tooltip-bg: #242830;
  --bandwidth-pane-tooltip-fg: #f1f3f5;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
}

:root[data-theme="dark"] .bandwidth-pane__select .form-control,
:root[data-theme="dark"] .bandwidth-pane .bandwidth-pane__controls .form-control {
  background-color: #1a1d21;
  border-color: #3a3f44;
  color: #e9ecef;
}

:root[data-theme="dark"] .bandwidth-pane__select .form-control:focus,
:root[data-theme="dark"] .bandwidth-pane .bandwidth-pane__controls .form-control:focus {
  border-color: #4a9eff;
  box-shadow: 0 0 0 0.15rem rgba(74, 158, 255, 0.2);
}

:root[data-theme="dark"] .bandwidth-pane__select .list-group-item {
  background-color: #1a1d21;
  border-color: #2f343c;
  color: #e9ecef;
}

:root[data-theme="dark"] .bandwidth-pane__select .list-group-item:hover,
:root[data-theme="dark"] .bandwidth-pane__select .list-group-item-action:hover {
  background-color: #2a3038;
  color: #fff;
}

:root[data-theme="dark"] .bandwidth-pane__select .btn {
  color: #adb5bd;
}

.bandwidth-chart__tooltip {
  background: var(--bandwidth-pane-tooltip-bg);
  color: var(--bandwidth-pane-tooltip-fg);
  padding: 0.65rem 0.75rem;
  border-radius: 0.35rem;
  border: 1px solid var(--customer360-card-border, rgba(0, 0, 0, 0.12));
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  font-size: 0.85rem;
}

.bandwidth-chart__tooltip p {
  margin: 0;
}

@media (max-width: 767.98px) {
  .bandwidth-pane__header {
    align-items: flex-start;
  }

  .bandwidth-pane__controls {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/home.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;EAC9B,oCAAoC;EACpC,oCAAoC;EACpC,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,6BAA6B;EAC7B,yDAAyD;EACzD,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;EAC9B,oCAAoC;EACpC,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4CAA4C;EAC5C,uCAAuC;EACvC,wBAAwB;EACxB,sBAAsB;EACtB,qEAAqE;EACrE,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Home bandwidth graph chrome */\n\n.bandwidth-pane {\n  --customer360-muted: #6c757d;\n  --customer360-card-bg: #ffffff;\n  --customer360-card-border: #dee2e6;\n  --bandwidth-pane-muted: #6c757d;\n  --bandwidth-pane-grid: #dee2e6;\n  --bandwidth-pane-axis: #6c757d;\n  --bandwidth-pane-tooltip-bg: #ffffff;\n  --bandwidth-pane-tooltip-fg: #212529;\n  overflow: hidden;\n  padding: 0;\n}\n\n.bandwidth-pane__header {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.bandwidth-pane__controls {\n  gap: 0;\n}\n\n.bandwidth-pane__body {\n  padding: 0.75rem 1rem 1rem;\n}\n\n.bandwidth-pane__header .customer360-snapshot__title-block {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.bandwidth-pane__select .form-control,\n.bandwidth-pane .bandwidth-pane__controls .form-control {\n  background-color: transparent;\n  border: 1px solid var(--customer360-card-border, #dee2e6);\n  color: inherit;\n  border-radius: 0.35rem;\n}\n\n:root[data-theme=\"dark\"] .bandwidth-pane {\n  --customer360-muted: #9ca3af;\n  --customer360-card-bg: #1f1f1f;\n  --customer360-card-border: #2b2f33;\n  --bandwidth-pane-muted: #9ca3af;\n  --bandwidth-pane-grid: #3a3f44;\n  --bandwidth-pane-axis: #9ca3af;\n  --bandwidth-pane-tooltip-bg: #242830;\n  --bandwidth-pane-tooltip-fg: #f1f3f5;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);\n}\n\n:root[data-theme=\"dark\"] .bandwidth-pane__select .form-control,\n:root[data-theme=\"dark\"] .bandwidth-pane .bandwidth-pane__controls .form-control {\n  background-color: #1a1d21;\n  border-color: #3a3f44;\n  color: #e9ecef;\n}\n\n:root[data-theme=\"dark\"] .bandwidth-pane__select .form-control:focus,\n:root[data-theme=\"dark\"] .bandwidth-pane .bandwidth-pane__controls .form-control:focus {\n  border-color: #4a9eff;\n  box-shadow: 0 0 0 0.15rem rgba(74, 158, 255, 0.2);\n}\n\n:root[data-theme=\"dark\"] .bandwidth-pane__select .list-group-item {\n  background-color: #1a1d21;\n  border-color: #2f343c;\n  color: #e9ecef;\n}\n\n:root[data-theme=\"dark\"] .bandwidth-pane__select .list-group-item:hover,\n:root[data-theme=\"dark\"] .bandwidth-pane__select .list-group-item-action:hover {\n  background-color: #2a3038;\n  color: #fff;\n}\n\n:root[data-theme=\"dark\"] .bandwidth-pane__select .btn {\n  color: #adb5bd;\n}\n\n.bandwidth-chart__tooltip {\n  background: var(--bandwidth-pane-tooltip-bg);\n  color: var(--bandwidth-pane-tooltip-fg);\n  padding: 0.65rem 0.75rem;\n  border-radius: 0.35rem;\n  border: 1px solid var(--customer360-card-border, rgba(0, 0, 0, 0.12));\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\n  font-size: 0.85rem;\n}\n\n.bandwidth-chart__tooltip p {\n  margin: 0;\n}\n\n@media (max-width: 767.98px) {\n  .bandwidth-pane__header {\n    align-items: flex-start;\n  }\n\n  .bandwidth-pane__controls {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
